@if (canShowBackorderDeliveryTime() || deliveryFlag()) {
<div class="p-t-1 p-t-3-m p-t-3-s p-b-1 p-b-3-m p-b-3-s flex-column gap-16px">
    @if (canShowBackorderDeliveryTime()) {
    <p class="w-12 c1"
       [style.color]="'#BE5A17'">
        {{'Dispatched in' | translate}}&nbsp;
        {{backorderDeliveryTime() | optionLabel: 'backorder_delivery_time'}}
    </p>
    }
    @if (deliveryFlag()) {
    <p class="w-12 s2"
       [htmlBinding]="deliveryFlag() | optionLabel : 'delivery_flag'"></p>
    }
</div>
}